import React from 'react';
import {
  Typography, Box, Grid,
} from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';

const RepairProperty: React.FC<{ title: string, subtitle: string, isRejected?: boolean }> = ({
  title, subtitle, isRejected,
}) => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    width="100%"
    height="100%"
  >
    <div style={{
      border: '1px solid #F2F2F2',
      boxSizing: 'border-box',
      borderRadius: '4px',
      width: '100%',
      height: '100%',
      paddingLeft: '1rem',
      paddingBottom: '0.75rem',
      paddingTop: '0.75rem',
      display: 'flex',
      flexFlow: 'wrap',
    }}
    >
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item>
          <Typography variant="h5" style={{ fontSize: '1.75rem', width: '100%' }}>{title}</Typography>
          <Typography
            style={{
              color: 'rgba(0, 0, 0, 0.6)', fontSize: '0.75rem', width: '100%', minHeight: '1.3125rem',
            }}
            variant="subtitle1"
          >
            {subtitle}
          </Typography>
        </Grid>
        {isRejected === true && (
          <Grid item>
            <WarningIcon style={{
              color: 'red', fontSize: '2rem', paddingBottom: '1rem', paddingRight: '1rem',
            }}
            />
          </Grid>
        )}
      </Grid>
    </div>
  </Box>
);

export default RepairProperty;
